import { render, staticRenderFns } from "./divpage.vue?vue&type=template&id=6e21dc8c&scoped=true&"
import script from "./divpage.vue?vue&type=script&lang=js&"
export * from "./divpage.vue?vue&type=script&lang=js&"
import style0 from "./divpage.vue?vue&type=style&index=0&id=6e21dc8c&prod&lang=less&scoped=true&"
import style1 from "./divpage.vue?vue&type=style&index=1&id=6e21dc8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e21dc8c",
  null
  
)

export default component.exports